"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.array.for-each");require("core-js/modules/es.array.index-of");require("core-js/modules/es.object.assign");require("core-js/modules/es.object.to-string");require("core-js/modules/es.promise");require("core-js/modules/es.regexp.exec");require("core-js/modules/es.string.replace");require("core-js/modules/web.dom-collections.for-each");exports.__esModule = true;exports.default = void 0;var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("whatwg-fetch");

var _is = require("./is");
var _json = require("./json");
var _obj = require("./obj");
var _prepareRequestBody = _interopRequireDefault(require("./prepareRequestBody"));


















/**
                                                                                    * Отправка запросов
                                                                                    *
                                                                                    *
                                                                                    * @class Rest
                                                                                    */var
Rest = /*#__PURE__*/function () {
  /**
                                  * Адрес api без роутов
                                  *
                                  * @type {string}
                                  * @example
                                  * https://api.addreality.com
                                  * @memberof Rest
                                  */






  /**
                                      * Заголовки, отправляемые с каждым запросом
                                      *
                                      * @type {StringsMap}
                                      * @example
                                      * {
                                      *   'X-Access-Token': 'qwfg34gtrb
                                      * }
                                      * @memberof Rest
                                      */



  /**
                                          *Creates an instance of Rest.
                                          * @param {{ baseUrl: string, defaultHeaders?: StringsMap }} opts
                                          * @memberof Rest
                                          */
  function Rest(opts) {(0, _defineProperty2.default)(this, "baseUrl", void 0);(0, _defineProperty2.default)(this, "middlewares", []);(0, _defineProperty2.default)(this, "defaultHeaders", void 0);
    this.baseUrl = opts.baseUrl.replace(/\/$/, '');
    this.defaultHeaders = (0, _is.isObj)(opts.defaultHeaders) ? opts.defaultHeaders : {};
  }

  /**
     * Возвращает полный url
     *
     * @param {string} url
     * @param {mixed} [query]
     * @example
     * this.getUrl( '/devices', '?status=1' )
     * // https://api.addreality.com/devices?status=1
     * @returns {string}
     * @memberof Rest
     */var _proto = Rest.prototype;_proto.
  getUrl = function getUrl(url, query) {
    var isAbsolute = url.indexOf('http') === 0;
    var u = isAbsolute ? url : this.baseUrl + url;
    if ((0, _is.isStr)(query)) {
      u += query;
    }
    return u;
  };_proto.

  _getHeaders = function _getHeaders(headers) {
    return Object.assign({}, this.defaultHeaders, (0, _is.isObj)(headers) ? headers : {});
  }

  // eslint-disable-next-line max-params
  ;_proto._prepareAndSend = function _prepareAndSend(method, urlIn, bodyIn, optsIn) {
    var opts = (0, _is.isObj)(optsIn) ? optsIn : {};
    var query = (0, _prepareRequestBody.default)({ body: opts.query, as: 'query' });
    var url = this.getUrl(urlIn, query);
    return fetch(url, {
      method: method,
      headers: this._getHeaders(opts.headers),
      body: (0, _prepareRequestBody.default)({ body: bodyIn, as: opts.as }) });

  }



  /**
     * Добавляет прослойку, которая принимает RespType и возвращает (изменённый или нет) RespType
     *
     * @param {MiddlewareType} middleware
     * @example
     * resp.addMiddleware( ( resp ) => {
     *   if ( resp.hasErr ) {
     *     console.error( resp )
     *   }
     *   return resp
     * } )
     * @memberof Rest
     */;_proto.
  addMiddleware = function addMiddleware(middleware) {
    this.middlewares.push(middleware);
  };_proto.



  _handleResp = function _handleResp(promise) {
    var pr = Rest._convertResp(promise);var
    middlewares = this.middlewares;

    if (middlewares.length === 0) {
      return pr;
    }

    return pr.then(function (resp) {
      var changedResp = resp;
      middlewares.forEach(function (middleware) {
        changedResp = middleware(changedResp);
      });
      return changedResp;
    });
  };Rest.



  _convertResp = function _convertResp(promise) {
    var unknowErr = { code: -1, message: 'unknown error' };

    var sts;

    return promise.then(function (resp) {
      sts = resp.status;
      return resp.text();
    }).
    then(function (respText) {
      var parsed = respText === '' ? {} : (0, _json.parseObj)(respText);
      var isParsedNull = parsed === null;
      var data = parsed === null ? {} : parsed;

      var hasErr = (0, _obj.hasProp)(data, 'error') || sts !== 200;

      if (hasErr) {
        var errData = isParsedNull ? unknowErr : data;
        if ((0, _obj.hasProp)(data, 'error')) {
          // $FlowFixMe
          errData = data.error;
        }
        return {
          hasErr: hasErr,
          status: sts,
          respText: respText,
          error: errData };

      }
      return {
        hasErr: hasErr,
        status: sts,
        respText: respText,
        // $FlowFixMe
        data: (0, _obj.hasProp)(data, 'response') ? data.response : data };

    }).
    catch(function (error) {return {
        hasErr: true,
        status: sts,
        respText: '',
        error: error };});

  }



  /**
     * Создаёт объект соответсвующий RespSuccessType с переданным аргументом в поле data
     *
     * @static
     * @param {T} data
     * @returns {RespSuccessType<T>}
     * @memberof Rest
     */;Rest.
  generateSuccessResp = function generateSuccessResp(data) {
    return Promise.resolve({
      hasErr: false,
      data: data,
      status: 200,
      respText: '' });

  }




  /**
     * Создаёт объект соответсвующий RespErrType с переданным аргументом в поле error
     *
     * @static
     * @param {T} error
     * @returns {RespErrType<T>}
     * @memberof Rest
     */;Rest.
  generateErrResp = function generateErrResp(error) {
    return Promise.resolve({
      hasErr: true,
      error: error,
      status: 500,
      respText: '' });

  }



  /**
     * Метод GET-запроса
     *
     * @param {string} urlIn
     * @param {?AnyMap} bodyIn
     * @param {AddonRequestOptsType} [optsIn]
     * @returns
     * @memberof Rest
     */;_proto.
  get = function get(urlIn, bodyIn, optsIn) {
    var opts = (0, _is.isObj)(optsIn) ? optsIn : {};
    var url = this.getUrl(urlIn, (0, _prepareRequestBody.default)({ body: bodyIn, as: 'query' }));
    return this._handleResp(fetch(url, {
      method: 'GET',
      headers: this._getHeaders(opts.headers) }));

  }

  /**
     * Метод POST-запроса
     *
     * @param {string} url
     * @param {?AnyMap} body
     * @param {AddonRequestOptsType} [opts]
     * @returns
     * @memberof Rest
     */;_proto.
  post = function post(url, body, opts) {
    return this._handleResp(this._prepareAndSend('POST', url, body, opts));
  }


  /**
     * Метод PUT-запроса
     *
     * @param {string} url
     * @param {?AnyMap} body
     * @param {AddonRequestOptsType} [opts]
     * @returns
     * @memberof Rest
     */;_proto.
  put = function put(url, body, opts) {
    return this._handleResp(this._prepareAndSend('PUT', url, body, opts));
  }



  /**
     * Метод DELETE-запроса
     *
     * @param {string} url
     * @param {?AnyMap} body
     * @param {?AddonRequestOptsType} [opts]
     * @returns
     * @memberof Rest
     */;_proto.
  del = function del(url, body, opts) {
    return this._handleResp(this._prepareAndSend('DELETE', url, body, opts));
  };return Rest;}();exports.default = Rest;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Rest.js
// module id = 616
// module chunks = 0